export const setInProgressTasks = {
  SET_IN_PROGRESS_TASKS(state, payload) {
    state.tasks = payload;
  }
};
